/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export function getOfferAction(offerId: string): Promise<ApiResponse<any>> {
  return api.get<ApiResponse<any>>(`/offers/${offerId}`)
}
